import { render, staticRenderFns } from "./sales-card-nav.vue?vue&type=template&id=4a9af10b"
import script from "./sales-card-nav.vue?vue&type=script&lang=js"
export * from "./sales-card-nav.vue?vue&type=script&lang=js"
import style0 from "./sales-card-nav.vue?vue&type=style&index=0&id=4a9af10b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports